module.exports = __webpack_public_path__ + "img/Recurso 61@300x.4c979c52.png";